import React from "react";
import { Navigate, redirect, useLocation, useNavigate } from "react-router-dom";
import { LoadAccountByToken } from "../../data/usecases/load-account-by-token";
import { LocalStorageAdapter } from "../../infra/cache";
import { CircularProgress, Container, Typography } from "@mui/material";
import { AccountModel } from "../../domain/models";
import Navbar from "../pages/components/navbar";

type Props = {
  loadAccountByToken: LoadAccountByToken;
  localStorageAdapter: LocalStorageAdapter;
  whiteList: string[];
  children: React.ReactNode;
  redirectUnauthorized?: string;
};

export default function PrivateRoute({
  loadAccountByToken,
  localStorageAdapter,
  whiteList,
  children,
  redirectUnauthorized,
}: Props) {
  const [user, setUser] = React.useState<AccountModel | null>(null);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [finished, setFinished] = React.useState<boolean>(false);

  React.useEffect(() => {
    async function fetch() {
      try {
        const account = localStorageAdapter.get("account");
        const user = await loadAccountByToken.loadByToken({
          token: account.accessToken,
        });
        setUser(user);
        setIsLoading(true);
      } catch (error) {
      } finally {
        setIsLoading(false);
        setFinished(true);
      }
    }
    fetch();
  }, []);

  if (isLoading) {
    return (
      <Container
        sx={{
          width: "100vw",
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress />
      </Container>
    );
  }

  if (finished && !user) {
    return <Navigate to={"/login"} />;
  }

  if (finished && user) {
    if (!whiteList.includes("*") && !whiteList.includes(user?.role?.name!)) {
      return redirectUnauthorized ? (
        <Navigate to={redirectUnauthorized} />
      ) : (
        <>
          <Navbar title="" />
          <Container
            sx={{
              width: "100vw",
              height: "100vh",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography>Não Autorizado</Typography>
          </Container>
        </>
      );
    }
  }

  return <>{children}</>;
}
